import { MONEY_SECTION } from '../../../data/site';

export function MoneySection() {
  return (
    <section className="money">
      <div className="container">
        <div className="money-wrap">
          <div className="section-header-wrap">
            <div className="section-header-left">
              <div className="heading-wrap">
                <h2>{MONEY_SECTION.title}</h2>
              </div>
              <div className="subtitle-wrap left-small">
                <div className="paragraph-02 text-dark-grey-two">{MONEY_SECTION.subtitle}</div>
              </div>
            </div>
          </div>
          <div className="money-main-wrap">
            <div className="money-column">
              <div data-w-id="177a1cf6-939f-22ec-d907-3a3a4f15ac5f" style={{WebkitTransform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', MozTransform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', msTransform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', transform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', opacity: '0', filter: 'blur(5px)'}} className="money-card-one">
                <div className="money-image-wrap">
                  <img src={MONEY_SECTION.quoteImage} loading="lazy" alt={MONEY_SECTION.quoteImageAlt} className="fit-cover" />
                  <div className="money-image-cover">
                  </div>
                </div>
                <div className="money-card-one-content">
                  <div className="money-one-text-wrap">
                    <div className="text-style-h4 text-white">
                      &quot;{MONEY_SECTION.quote}&quot;
                    </div>
                    <div className="paragraph-02 money-one-subtitle">
                      {MONEY_SECTION.quoteSub}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="money-column">
              <div data-w-id="ab11bfe5-b87e-3c1b-3e96-033f673d7141" style={{WebkitTransform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', MozTransform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', msTransform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', transform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', opacity: '0', filter: 'blur(5px)'}} className="money-card-two">
                <div className="money-two-content">
                  <div className="text-style-h4">
                    {MONEY_SECTION.cardTwoLabel}
                  </div>
                  <div className="paragraph-02 text-dark-grey-two">
                    {MONEY_SECTION.cardTwoSub}
                  </div>
                </div>
                <div className="paragraph-02 text-dark-grey-two">
                  {MONEY_SECTION.cardTwoTagline}
                </div>
              </div>
              <div data-w-id="01021bb4-3db1-169e-b46f-fe7be5a12fd8" style={{WebkitTransform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', MozTransform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', msTransform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', transform: 'translate3d(0, 50px, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)', opacity: '0', filter: 'blur(5px)', backgroundImage: `url(${MONEY_SECTION.cardThreeImage})`}} className="money-card-three">
                <div className="money-card-three-content">
                  <div className="text-style-h4 text-white">
                    {MONEY_SECTION.cardThreeTitle}
                  </div>
                  <div className="money-button-wrap">
                    <a href="/waitlist" className="button w-variant-6cc8cb48-f4c6-5f39-f8af-bcfb630263e0 w-inline-block">
                      <div className="button-text-wrap">
                        <div className="button-text-group">
                          <div className="paragraph-02 button-text-wrap w-variant-6cc8cb48-f4c6-5f39-f8af-bcfb630263e0">
                            {MONEY_SECTION.cardThreeButton}
                          </div>
                          <div className="paragraph-02 button-text-wrap w-variant-6cc8cb48-f4c6-5f39-f8af-bcfb630263e0">
                            {MONEY_SECTION.cardThreeButton}
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
